<template>
    <div id="app">
      <hello />
    </div>
  </template>
  <script>
  import  hello from './components/hello'
  export default {
      name: 'app',
      components:{
          hello
    },
  }
  </script>